class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      // On the search page the form sits inside both <predictive-search> and
      // <main-search>, so guard against binding the submit handler twice.
      if (this.input.form.dataset.searchScope && !this.input.form.dataset.searchScopeBound) {
        this.input.form.dataset.searchScopeBound = 'true';
        this.input.form.addEventListener('submit', this.onScopedFormSubmit.bind(this));
      }
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  // Prepend the product scope so each artwork returns one result. It goes before the
  // typed terms so `options[prefix]` keeps applying to what the visitor actually typed.
  // Named distinctly from PredictiveSearch's own onFormSubmit, which this would shadow.
  onScopedFormSubmit(event) {
    const terms = this.input.value.trim();
    // A highlighted predictive result owns the Enter key — let its link handle it.
    if (!terms || document.querySelector('[aria-selected="true"] a')) return;

    event.preventDefault();
    const params = new URLSearchParams({
      q: `${this.input.form.dataset.searchScope} ${terms}`,
      'options[prefix]': 'last',
    });
    window.location.assign(`${this.input.form.action}?${params}`);
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
